import useAnnouncements from './useAnnouncements'
import { useChallengeId } from '../challenge/useChallengeId'
import { useHasEngagement, useUserEngagements } from '../engagement/useUserEngagements'

export function useFullscreenAnnouncement(): { pending: boolean; active: boolean } {
  const challengeId = useChallengeId()
  const announcements = useAnnouncements(challengeId)
  const engagements = useUserEngagements()
  const candidate = announcements.data?.find((item) => item.fullscreen && item.videoUrl)
  const seen = useHasEngagement('announcement', candidate?.id)
  const pending = announcements.isPending || engagements.isPending

  return {
    pending,
    active: !pending && Boolean(candidate && !seen),
  }
}
